<script setup lang="ts">

</script>

<template>
	<div class="layout layout--article">
		<MobileHeader />
		<div class="main-container">
			<div class="main-wrapper">
				<main class="main">

					<div class="container:xl px:0">
						<div class="main__inner">
							<ArticleSidebar />

							<div class="main__body">
								<slot />
							</div>
						</div>
					</div>

				</main>
			</div>
		</div>
	</div>
</template>

<style lang="scss">
@layer layout
{
	.layout--article
	{
		min-height:100dvh;

		.main
		{
			&__inner
			{
				display:grid;
				grid-template-columns:minmax(0, 1fr);

				@include responsive(lg)
				{
					grid-template-columns:34.8rem minmax(0, 1fr);
				}
			}
			&__body
			{
				min-height:0;
				padding:$spacing-5xl $spacing-md;
			}
		}
	}
}
</style>
